export function initializeSentry(): void {
  if (!sentryIsActivated()) {
    return
  }

  const scriptSrc = 'https://js-de.sentry-cdn.com/dfb008b3d5e41385d69de71c875c3a10.min.js'

  if (document.querySelector(`script[src="${scriptSrc}"]`)) {
    return
  }

  try {
    const script = document.createElement('script')
    script.src = scriptSrc
    script.crossOrigin = 'anonymous'
    document.head.appendChild(script)
  } catch (error) {
    console.error('Failed to load Sentry script:', error)
  }
}

const sentryIsActivated = (): boolean => {
  const currentHost = window.location.hostname
  return currentHost === 'docmine-scrollstories.netlify.app'
}
